// Cross-route anchor support — when the URL changes to include a `#hash`
// (e.g. user clicks "Our story" from /tutorial → routes to "/#story"),
// React Router does NOT auto-scroll to the anchor. This helper listens for
// hash changes and scrolls to the matching element id.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToHash() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) return;
        const id = hash.replace(/^#/, "");
        if (!id) return;
        // Two RAFs + small delay so the destination route has mounted its
        // section components before we attempt to scroll. Required when
        // changing pages (e.g. /tutorial → /#story) since the home page is
        // still mounting at the moment the hash arrives.
        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        };
        const timer = setTimeout(tryScroll, 220);
        return () => clearTimeout(timer);
    }, [pathname, hash]);
    return null;
}
